import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MaterialModuleModule } from './material-module/material-module.module';
import { DhwaniLoginDefaultModule } from 'dhwani-login-default';
import { AuthModuleModule } from '../auth-module/auth-module.module';


import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RegistrationDialogComponent } from './components/registration-dialog/registration-dialog.component';
// import { RegistrationDialogComponent } from '../auth-module/components/dialogs/registration-dialog/registration-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    RegistrationDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleModule,
    MatInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSelectModule,
    MatMenuModule
    // MatSlideToggleModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MatInputModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSelectModule,
    MatMenuModule
    // MatSlideToggleModule
    // MatProgressSpinnerModule
  ],
  entryComponents: [RegistrationDialogComponent]
})
export class SharedModuleModule { }
